import { OwcInput, OwcSlideToggle } from "@one/react";
import { FormikProps } from "formik";
import { react18WorkaroundProps } from "../../../../utils/constants/react18WorkaroundProps";
import { ACTION_LOG_ACTION_TYPE } from "../../../../constants";
import { useFieldPropagationToggle } from "../../../../utils/hooks/useFieldPropagationToggle";
import { useEffect } from "react";
export const SoftwareInputWithSwitch = ({
  formik,
  isPropagationDisabled,
  numberOfSelectedEquipment,
  editMode,
  defaultValue = ''
}: {
  formik: FormikProps<{
    updatedSoftwareVersion: {
      newValue: string;
      shouldBePublished: boolean;
    };
    action: string;
  }>;
  isPropagationDisabled?: boolean;
  numberOfSelectedEquipment: number;
  editMode: boolean;
  defaultValue: string;
}) => {
  const isBulk = numberOfSelectedEquipment > 1;
  const bulkDefaultValue = numberOfSelectedEquipment > 1 || defaultValue === null ? '' : defaultValue;
  const isPropagationToggleDisabled = formik.values.action !== ACTION_LOG_ACTION_TYPE.SOFTWARE_CHANGE || editMode || isPropagationDisabled;

  const { isToggleDisabled } = useFieldPropagationToggle({
    formikValue: formik.values.updatedSoftwareVersion,
    defaultValue: bulkDefaultValue,
    label: "updatedSoftwareVersion",
    setFieldValue: formik.setFieldValue,
    disabled: isPropagationToggleDisabled
  });

  useEffect(() => {
    if (formik.values.action === ACTION_LOG_ACTION_TYPE.SOFTWARE_CHANGE) {
      formik.setFieldValue("updatedSoftwareVersion.newValue", bulkDefaultValue);
    }

    if (formik.values.action !== ACTION_LOG_ACTION_TYPE.SOFTWARE_CHANGE && formik.values.updatedSoftwareVersion?.newValue) {
      formik.setFieldValue("updatedSoftwareVersion.newValue", "");
      formik.setFieldValue("updatedSoftwareVersion.shouldBePublished", false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.action]);

  return formik.values.action === ACTION_LOG_ACTION_TYPE.SOFTWARE_CHANGE ? (
    <div style={{ gridColumn: "span 2" }}>
      <OwcInput
        {...react18WorkaroundProps}
        onBlur={formik.handleBlur}
        data-testid="action-data-inputs-new-software-version-input"
        variant="filled"
        id="updatedSoftwareVersion.newValue"
        name="updatedSoftwareVersion.newValue"
        label={"Software version"}
        value={formik.values.updatedSoftwareVersion.newValue}
        onInputChange={formik.handleChange}
        onInputKeyDown={formik.handleChange}
        style={{
          width: "100%"
        }}
      >
        {isBulk ? <span slot="assistive-text">Empty means “Keep current values”, Filled means “Set all to new value”</span> : null}
      </OwcInput>
      <OwcSlideToggle
        {...react18WorkaroundProps}
        checked={formik.values.updatedSoftwareVersion.shouldBePublished}
        onInputChange={(event: { detail: any }) =>
          formik.setFieldValue("updatedSoftwareVersion.shouldBePublished", event.detail)
        }
        id="updatedSoftwareVersion.shouldBePublished"
        disabled={editMode || isPropagationDisabled || isToggleDisabled}
      >
        Publish ”Software version” to Equipment Repository
      </OwcSlideToggle>
    </div>
  ) : (
    <></>
  );
};
